
































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Cow } from '@/interfaces/Cow'
import TimeService from '@/services/time-service'
import CowService from '@/services/cow-service'
import DexieService from '@/services/dexie-service'
import CowIcon from '@/components/CowIcon.vue'
import axios from 'axios'
import ApiService from '@/services/api-service'
import SnackbarService from '@/services/snackbar-service'
import AddView from '@/components/AddView.vue'

@Component({
  components: {
    CowIcon,
    AddView,
  },
})
export default class ListView extends Mixins(
  TimeService,
  CowService,
  DexieService,
  ApiService,
  SnackbarService
) {
  selected: Cow[] = []

  selectedChangeCows: Cow[] = []

  cowsChangeFarm: Cow[] = []

  oldSelected: Cow[] = []

  cows: Cow[] = []

  filteredCows: Cow[] = []

  selectedFilterCount = 0

  filterSelection = 0

  filterFemale = 0

  searchChangeFarm = ''

  urlState = 'cows'

  verifyRevisionModalIsOpen = false

  addCowModalIsOpen = false

  changeFarmModalIsOpen = false

  verifyChangeCowsDialogIsOpen = false

  verifyDeleteCowsDialogIsOpen = false

  selectedFarmToChange = ''

  openSelectedAll = {
    isOpen: false,
    text: '',
    buttonText: '',
    selectAll: false,
  }

  filterIsOpen = false
  headers: any = []

  defaultHeaders = [
    { text: 'Numero', value: 'number' },
    { text: 'Genero', value: 'female' },
    { text: 'Fertilidad', value: 'fertility' },
    { text: 'Raza', value: 'race_id' },
    { text: 'Color', value: 'color' },
    { text: 'Preñez', value: 'pregnantSince' },
    { text: 'Hierro', value: 'iron_id' },
    { text: 'Edad', value: 'age' },
    { text: 'Observacion', value: 'observation' },
  ]

  filters: any = this.getDefaultFilters()

  checkOpenDialogSelectAll(items: Cow[], value: boolean) {
    if (this.$store.state.user.id === 1) {
      return
    }
    if (value) {
      this.openSelectedAll.text = `Estas seguro que quieres seleccionar todos los ${this.filteredCows.length} vacas visibles?`
      this.openSelectedAll.isOpen = true
      this.openSelectedAll.buttonText = 'Seleccionar todo'
      this.openSelectedAll.selectAll = true
    } else {
      this.openSelectedAll.text = `Estas seguro que quieres deseleccionar todos los ${
        this.filteredCows.filter((c: Cow) => c.selected).length
      } vacas visibles?`
      this.openSelectedAll.isOpen = true
      this.openSelectedAll.buttonText = 'Deseleccionar todo'
      this.openSelectedAll.selectAll = false
    }
  }

  chancelSelectAll() {
    this.selected = this.oldSelected
    this.openSelectedAll.isOpen = false
  }

  sendOneSelected(selectedItem: any) {
    if (this.$store.state.user.id === 1) {
      return
    }
    const cow = selectedItem.item
    const selected = selectedItem.value
    const url = `/cows/${cow.id}`
    const payload = { selected }
    const selectedCow = this.cows.find((c: Cow) => c.id === cow.id)
    if (navigator.onLine) {
      axios.patch(url, payload).then(() => {
        if (selectedCow) {
          selectedCow.selected = selected
        }
      })
    } else {
      this.$db.syncs
        .add({
          number: selectedCow.number,
          method: 'patch',
          url,
          payload,
          timestamp: new Date().toISOString(),
          farm_id: this.$store.state.selectedFarmId,
          action: 'Selection: Cambiar selected',
          message: `Selected: ${payload.selected}`,
        })
        .then(() => {
          this.$db.cows.update(selectedCow.id, payload)
        })
    }
  }

  sendAllSelected() {
    this.openSelectedAll.isOpen = false
    const url = `/${this.$store.state.selectedFarmId}/selected`
    let selected
    let selectedCows
    if (this.openSelectedAll.selectAll) {
      selected = this.filteredCows.map((cow: Cow) => cow.id)
      selectedCows = this.filteredCows
    } else {
      selected = []
      selectedCows = []
    }
    const payload = {
      selected,
    }
    this.selected = selectedCows
    setTimeout(() => {
      this.updatedRemainingSelected()
      if (navigator.onLine) {
        this.oldSelected = this.selected
        axios
          .post(url, payload)
          .then(() => {
            this.dbUpdateAllSelected(this.selected)
          })
          .catch(error => {
            this.notify({ text: `Server error. ${error}` })
            this.selected = this.oldSelected
            this.updatedRemainingSelected()
          })
      } else {
        this.$db.syncs
          .add({
            method: 'post',
            url,
            payload,
            timestamp: new Date().toISOString(),
            farm_id: this.$store.state.selectedFarmId,
            action: 'Revision: Cambiar revision',
            message: `Revisados: ${payload.selected.length}`,
          })
          .then(() => {
            this.dbUpdateAllSelected(this.selected)
            this.updatedRemainingSelected()
          })
      }
    }, 500)
  }

  getDefaultFilters() {
    return {
      select: {
        iron_id: [],
        race_id: [],
        fertility: [],
      },
      range: {
        age: [this.getMinAge(), this.getMaxAge() + 1],
        pregnantSince: [
          this.getMinPregnantSince(),
          this.getMaxPregnantSince() + 1,
        ],
      },
      search: '',
    }
  }

  setSelectedFilterCount() {
    let count = 0
    Object.keys(this.filters.select).forEach((key: string) => {
      if (this.filters.select[key].length > 0) {
        count++
      }
    })
    if (
      Math.floor(this.filters.range.age[0]) !== 0 ||
      this.filters.range.age[1] !== this.getMaxAge() + 1
    ) {
      count++
    }
    if (this.$store.state.filters.pregnantOverdue) {
      count++
    } else {
      if (
        this.filters.range.pregnantSince[0] !== this.getMinPregnantSince() ||
        this.filters.range.pregnantSince[1] !== this.getMaxPregnantSince() + 1
      ) {
        count++
      }
    }
    if (this.filterSelection !== 0) {
      count++
    }
    if (this.filterFemale !== 0) {
      count++
    }
    this.selectedFilterCount = count
  }

  mounted() {
  
    if (!this.$store.state.account) {
      return
    }
    if (this.$store.state.filters.select) {
      this.filters = this.$store.state.filters
    }
    this.headers = JSON.parse(JSON.stringify(this.defaultHeaders))
    if (['cows-sold', 'cows-dead'].includes(this.$route.name)) {
      this.urlState = this.$route.name
      this.$store.state.navbarText =
        this.urlState === 'cows-sold' ? 'Vendidos' : 'Muertos'
    } else {
      this.$store.state.navbarText = this.$store.state.account.farms.find(
        f => f.id === this.$store.state.selectedFarmId
      ).name
      this.urlState = 'cows'
    }
    if (this.urlState === 'cows-sold') {
      this.headers.push({ text: 'Dia de vender', value: 'date_of_sell' })
    } else if (this.urlState === 'cows-dead') {
      this.headers.push({ text: 'Dia de muerto', value: 'date_of_death' })
    }
    this.$store.state.showAppbar = true
    this.$store.state.changeBack = '/home'
    this.getCows()
    this.getAllCowsUpdateCache()
  }

  goToDetail(event: any) {
    this.$router.push(`/cows/${event.id}`)
  }

  updatedRemainingSelected() {
    this.filteredCows.forEach((c: Cow) => {
      const selectedIds = this.selected.map((c: Cow) => c.id)
      if (selectedIds.includes(c.id)) {
        c.selected = true
      } else {
        c.selected = false
      }
    })
  }

  changeGender() {
    if (
      this.filters.range.pregnantSince[0] !== this.getMinPregnantSince() ||
      this.filters.range.pregnantSince[1] !== this.getMaxPregnantSince() + 1
    ) {
      this.filterFemale = 1
    }
  }

  applyFilters(update) {
    let cows = this.cows
    Object.keys(this.filters.select).forEach((key: string) => {
      if (this.filters.select[key].length > 0) {
        cows = cows.filter((cow: Cow) => {
          return (
            Object.keys(cow).includes(key) &&
            this.filters.select[key].includes(cow[key] ? cow[key] : null)
          )
        })
      }
    })

    /* Filter pranantSince */
    if (this.$store.state.filters.pregnantOverdue) {
      cows = cows.filter((cow: Cow) => cow.pregnantSince > 8)
    } else {
      let upperPregnantSince
      if (
        this.filters.range.pregnantSince[1] ===
        this.getMaxPregnantSince() + 1
      ) {
        upperPregnantSince = 100
      } else {
        upperPregnantSince = this.filters.range.pregnantSince[1]
      }
      cows = cows.filter(
        (cow: Cow) =>
          cow.pregnantSince >= this.filters.range.pregnantSince[0] &&
          cow.pregnantSince <= upperPregnantSince
      )
    }

    /* Filter age */
    let upperAge
    if (this.filters.range.age[0] === this.getMaxAge() + 1) {
      upperAge = 100
    } else {
      upperAge = this.filters.range.age[1]
    }
    cows = cows.filter(
      (cow: Cow) => cow.age >= this.filters.range.age[0] && cow.age <= upperAge
    )

    /* Filter revisioned */
    if (this.filterSelection === 1) {
      cows = cows.filter((cow: Cow) => cow.selected)
    } else if (this.filterSelection === 2) {
      cows = cows.filter((cow: Cow) => !cow.selected)
    }

    /* Filter female */
    if (this.filterFemale === 1) {
      cows = cows.filter((cow: Cow) => cow.female)
    } else if (this.filterFemale === 2) {
      cows = cows.filter((cow: Cow) => !cow.female)
    }

    this.setSelectedFilterCount()
    this.filteredCows = cows
    if (!update) {
      this.filterIsOpen = false
    }
  }

  deleteFilters() {
    this.$store.state.filters.pregnantOverdue = false
    this.selectedFilterCount = 0
    this.filteredCows = this.cows
    this.filters = this.getDefaultFilters()
    this.filterIsOpen = false
    this.filterFemale = 0
  }

  getCows() {
    this.addCowModalIsOpen = false
    this.$store.state.loading = true
    if (navigator.onLine) {
      axios
        .get(`/${this.urlState}`)
        .then(res => {
          let cows = res.data
          if (cows.length === 0) {
            this.cows = []
            this.filteredCows = []
            return
          }

          // update index db
          this.$db.cows.clear().then(() => {
            this.$db.cows.bulkPut(res.data)
          })

          // filter for farm if on cows (not sold or dead)
          if (this.urlState === 'cows') {
            cows = cows.filter(
              cow => cow.farm_id === this.$store.state.selectedFarmId
            )
          }

          this.cows = this.addPregnantSinceAndAge(cows)
          this.addAdditionalCols()
          this.filteredCows = this.cows
          this.applyFilters(true)
          this.selected = this.cows.filter((cow: Cow) => cow.selected)
          this.oldSelected = this.selected
        })
        .catch(error => {
          this.notify({ text: `Server error. ${error}` })
          this.cows = []
          this.filteredCows = []
        })
        .finally(() => {
          this.$store.state.loading = false
        })
    } else {
      const status =
        this.urlState === 'cows'
          ? 'possession'
          : this.urlState === 'cows-sold'
          ? 'sold'
          : 'dead'
      this.$db.cows
        .where({ status })
        .toArray()
        .then((cows: Cow[]) => {
          if (this.urlState === 'cows') {
            cows = cows.filter(
              cow => cow.farm_id === this.$store.state.selectedFarmId
            )
          }
          this.cows = this.addPregnantSinceAndAge(cows)
          this.addAdditionalCols()
          this.filteredCows = this.cows
          this.selected = this.cows.filter((cow: Cow) => cow.selected)
          // this.notify({ text: 'Using offline data', type: 'warning' })
          this.$store.state.loading = false
        })
    }
  }

  saveRevision() {
    this.verifyRevisionModalIsOpen = false
    this.$store.state.loading = true
    axios
      .post(`/revisions/${this.$store.state.selectedFarmId}`)
      .then(() => {
        this.notify({ text: 'Revision guardado exitosamente', type: 'success' })
      })
      .catch(error => {
        let message
        if (error.response && error.response.status === 400) {
          message = `Revision por hoy ya existe`
        } else {
          message = `Server error. ${error}`
        }
        this.notify({ text: message })
      })
      .finally(() => {
        this.$store.state.loading = false
      })
  }

  openChangeBulkModal() {
    this.$store.state.loading = true
    this.selectedChangeCows = []
    this.cowsChangeFarm = JSON.parse(JSON.stringify(this.cows))
    this.cowsChangeFarm.forEach((c: Cow) => {
      c.selected = false
    })
    this.changeFarmModalIsOpen = true
    this.$store.state.loading = false
  }

  async changeFarm() {
    this.$store.state.loading = true
    const farm_id = this.selectedFarmToChange
    let sucess = 0
    let counter = 0
    for await (const cow of this.selectedChangeCows) {
      counter += 1
      const id = cow.id
      const payload = {
        farm_id,
        observation:
          cow.observation +
          `${cow.observation === '' ? '' : '; '}` +
          `Viene de ${
            this.$store.state.account.farms.find(
              (f: any) => f.id === this.$store.state.selectedFarmId
            ).name
          }`,
      }
      const url = `/cows/${id}`
      if (navigator.onLine) {
        await axios.patch(url, payload).then(() => (sucess += 1))
      } else {
        await this.$db.cows.update(cow.id, payload)
        sucess += 1
        this.$db.syncs.add({
          method: 'patch',
          farm_id,
          timestamp: new Date().toISOString(),
          number: cow.number,
          url,
          action: 'Vaca: Actualizar',
          message: `Actualizar ${Object.keys(payload)[0]} con ${
            Object.values(payload)[0]
          }`,
          payload,
        })
      }
      if (counter === this.selectedChangeCows.length) {
        if (sucess === this.selectedChangeCows.length) {
          const text = `Cambiado exitosamente ${
            this.$store.state.online ? '' : '(offline)'
          }`
          this.notify({ text, type: 'success' })
        } else {
          const text = `Error cambiar vacas ${
            this.$store.state.online ? '' : '(offline)'
          }`
          this.notify({ text })
        }
        this.changeFarmModalIsOpen = false
        this.verifyChangeCowsDialogIsOpen = false
      }
      this.getCows()
    }
  }

  deleteCows() {
    this.$store.state.loading = true
    const payload = { cow_ids: this.selectedChangeCows.map((c: Cow) => c.id) }
    const url = 'cows-delete'
    if (navigator.onLine) {
      axios
        .post(url, payload)
        .then(() => {
          this.notify({ text: 'Deleted successfully', type: 'success' })
          this.changeFarmModalIsOpen = false
          this.verifyDeleteCowsDialogIsOpen = false
          this.getCows()
        })
        .catch(() => {
          this.$store.state.loading = false
        })
    } else {
      this.$db.cows.bulkDelete(payload.cow_ids)
      this.$db.syncs.add({
        method: 'post',
        farm_id: this.$store.state.selectedFarmId,
        timestamp: new Date().toISOString(),
        url,
        action: 'Vaca: Eliminar multiples',
        message: `Eliminar vacas ${this.selectedChangeCows.map(
          (c: Cow) => c.number
        )}`,
        payload,
      })
      this.$store.state.loading = false
      this.changeFarmModalIsOpen = false
      this.verifyDeleteCowsDialogIsOpen = false
      this.getCows()
    }
  }

  toggleSelectAllBulk(items: any, value: boolean) {
    if (value) {
      this.selectedChangeCows = this.cowsChangeFarm
    } else {
      this.selectedChangeCows = []
    }
  }

  addAdditionalCols() {
    this.headers = JSON.parse(JSON.stringify(this.defaultHeaders))
    // additional cols
    let additionalColNames = []
    if (this.cows.length > 0) {
      additionalColNames = this.cows[0].additional_cols.map(
        (c: any) => c.col_def.name
      )
    }
    additionalColNames.forEach((colName: string) => {
      this.headers.push({ text: colName, value: colName })
    })
    this.cows.forEach((cow: Cow) => {
      cow.additional_cols.forEach((addCol: any) => {
        cow[addCol.col_def.name] = addCol.value
          ? addCol.value
          : addCol.option
          ? addCol.option.value
          : null
      })
    })
  }

  destroyed() {
    this.$store.state.filters = this.filters
  }

  get tableStyle() {
    const style = {}
    style[
      `bg-${this.$store.state.account.farms
        .map(f => f.id)
        .indexOf(this.$store.state.selectedFarmId)}`
    ] = true
    return style
  }
}
